// extracted by mini-css-extract-plugin
export default {"button":"styles_button__RWlVF","big":"styles_big__CvcRT"};